$(document).ready(function (){

    $("#table-customers").DataTable({
        proccesing: true,
        serverSide: true,
        language: {
            url: "https://cdn.datatables.net/plug-ins/2.0.3/i18n/es-ES.json"
        },
        responsive: true,
        ajax: 'get-customers',
        columns: [
            {data: 'fullName', name: 'fullName'},
            {data: 'email', name: 'email'},
            {data: 'phone', name: 'phone'},
            {data: 'numberOfPurchases', name: 'numberOfPurchases'},
        ],
        "columnDefs": [{
            "targets": 4,
            "data": "download_link",
            "render": function (data, type, row, meta) {
                return ""
            }
        }]
    });
    const list_users = $("#table-customers").DataTable()
})
